import { IRequestEventHandler } from "../common";
import { BaseDirRequest } from "./baseDirRequest";
import { ISupplierDataCheckDTO, ISupplierDataCheckViewDTO } from "../../coreapi-dto/dirs/supplierDataCheck";

class SupplierDataCheckRequest extends BaseDirRequest<ISupplierDataCheckViewDTO, ISupplierDataCheckDTO> {

    constructor(baseUrl:string, token:string, eventHandler: IRequestEventHandler){
        super(baseUrl, "SupplierDataChecks", token, eventHandler)
    }
}

export default SupplierDataCheckRequest